import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import PanelHeader from '@/components/renewal/common/panel-header.vue';
import { ref, computed, onBeforeMount, onMounted, onBeforeUnmount, watch } from 'vue';
import { Container, Draggable } from 'vue-smooth-dnd';
import Icon from '@/components/renewal/common/icon.vue';
import { useTelemetry } from '@/plugins/telemetry';
import { useRepositories } from '@/plugins/repositories';
import { useToast } from '@/plugins/vueToast';
import { VTabsItems } from 'vuetify/lib';
export default /*#__PURE__*/_defineComponent({
  __name: 'news-panel',
  setup: function setup(__props) {
    var SCROLL_DISTANCE = 80;
    var MOBILE_WIDTH = 600;
    var content = ref(null);
    var isMobile = ref(false);
    var totalCountLoading = ref(false);
    var totalCount = ref(0);
    var countByCategoryLoading = ref(false);
    var countByCategory = ref([]);
    var activeCategoryName = ref(null);
    var categoriesLoading = ref(false);
    var categories = ref([]);
    var news = ref([]);
    var loading = ref(false);
    var telemetry = useTelemetry();
    var route = useRoute();
    var repositories = useRepositories();
    var toast = useToast();
    var directories = {
      'ファイナンス・ディスクロージャー': '1/45',
      'エネルギー・インフラ': '2/10',
      会社法: '3/11',
      危機管理: '4/12',
      'M&A': '5/13',
      倒産: '6/16',
      '一般民事・債権管理': '7/18',
      '国際訴訟・仲裁': '7/19',
      '競争法/独禁法': '8/20',
      消費者法: '8/21',
      労働法: '9/22',
      税務: '10/23',
      知的財産法: '11/24',
      '医事・薬事': '12/28',
      海事: '12/29',
      通商: '13/34',
      IT: '11/46',
      行政法: '14/47',
      刑事: '15/48'
    };
    var ADDITIONAL_NEWS_COUNT = 10;
    var MOBILE_LOAD_COUNT = 3;
    var DEFAULT_LOAD_COUNT = 5;
    var firstLoad = ref(true);
    var showLoadMore = computed(function () {
      var count = getCount(activeCategoryName.value);
      return (count !== null && count !== void 0 ? count : 0) > getNews.value.length && !loading.value;
    });
    var onClickLoadMore = function onClickLoadMore() {
      fetchAdditionalData(activeCategoryName.value);
    };
    var fetchTotalCount = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              totalCountLoading.value = true;
              _context.next = 4;
              return repositories.news.getNewsCount();
            case 4:
              totalCount.value = _context.sent;
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
            case 10:
              _context.prev = 10;
              totalCountLoading.value = false;
              return _context.finish(10);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 7, 10, 13]]);
      }));
      return function fetchTotalCount() {
        return _ref.apply(this, arguments);
      };
    }();
    var fetchCountByCategory = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              countByCategoryLoading.value = true;
              _context2.next = 4;
              return repositories.news.getNewsCountByCategory();
            case 4:
              countByCategory.value = _context2.sent;
              _context2.next = 10;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              console.error(_context2.t0);
            case 10:
              _context2.prev = 10;
              countByCategoryLoading.value = false;
              return _context2.finish(10);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 7, 10, 13]]);
      }));
      return function fetchCountByCategory() {
        return _ref2.apply(this, arguments);
      };
    }();
    var getCount = function getCount(categoryName) {
      var _count$count;
      if (!categoryName) {
        return 0;
      }
      if (categoryName === '全て') {
        return totalCount.value;
      }
      var count = countByCategory.value.find(function (c) {
        return c.key == categoryName;
      });
      return (_count$count = count === null || count === void 0 ? void 0 : count.count) !== null && _count$count !== void 0 ? _count$count : null;
    };
    var fetchCategories = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              categoriesLoading.value = true;
              _context3.next = 4;
              return repositories.users.getUserNewsCategories();
            case 4:
              response = _context3.sent;
              categories.value = response.newsCategories;
              activeCategoryName.value = categories.value[0].name;
              _context3.next = 13;
              break;
            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](0);
              toast.error('ニュースカテゴリの取得に失敗しました');
              return _context3.abrupt("return");
            case 13:
              categoriesLoading.value = false;
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 9]]);
      }));
      return function fetchCategories() {
        return _ref3.apply(this, arguments);
      };
    }();
    var updateHeight = function updateHeight() {
      var _content$value;
      var contentElement = (_content$value = content.value) === null || _content$value === void 0 ? void 0 : _content$value.$el;
      if (contentElement && firstLoad.value) {
        // contentElement.offsetHeightがcontentの高さとして正しく計算されるように一度autoに設定する
        contentElement.style.setProperty('--content-height', 'auto');
        contentElement.style.setProperty('--content-height', "".concat(contentElement.offsetHeight, "px"));
      }
    };
    watch(activeCategoryName, function (newVal) {
      fetchData(newVal);
    });
    watch(isMobile, function () {
      nextTick(function () {
        return updateHeight();
      });
    });
    var fetchData = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(categoryName) {
        var category, categoryId;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              category = categories.value.find(function (c) {
                return c.name === categoryName;
              });
              if (category) {
                _context4.next = 3;
                break;
              }
              return _context4.abrupt("return");
            case 3:
              loading.value = true;
              firstLoad.value = true;
              news.value = [];
              categoryId = category.id;
              if (category.name === '全て') {
                categoryId = undefined;
              }
              _context4.prev = 8;
              _context4.next = 11;
              return repositories.news.getNews(categoryId);
            case 11:
              news.value = _context4.sent;
              _context4.next = 18;
              break;
            case 14:
              _context4.prev = 14;
              _context4.t0 = _context4["catch"](8);
              toast.error('ニュースの取得に失敗しました');
              return _context4.abrupt("return");
            case 18:
              loading.value = false;
              nextTick(updateHeight);
            case 20:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[8, 14]]);
      }));
      return function fetchData(_x) {
        return _ref4.apply(this, arguments);
      };
    }();
    var scrollContentDown = function scrollContentDown() {
      var _content$value2;
      var contentElement = (_content$value2 = content.value) === null || _content$value2 === void 0 ? void 0 : _content$value2.$el;
      if (contentElement) {
        contentElement.scrollTo({
          top: SCROLL_DISTANCE,
          behavior: 'smooth'
        });
      }
    };
    var fetchAdditionalData = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(categoryName) {
        var category, categoryId, _news$value, additionalNews;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              category = categories.value.find(function (c) {
                return c.name === categoryName;
              });
              if (category) {
                _context5.next = 3;
                break;
              }
              return _context5.abrupt("return");
            case 3:
              loading.value = true;
              if (firstLoad.value) {
                nextTick(scrollContentDown);
              }
              firstLoad.value = false;
              categoryId = category.id;
              if (category.name === '全て') {
                categoryId = undefined;
              }
              _context5.prev = 8;
              _context5.next = 11;
              return repositories.news.getNews(categoryId, news.value.length, ADDITIONAL_NEWS_COUNT);
            case 11:
              additionalNews = _context5.sent;
              (_news$value = news.value).push.apply(_news$value, _toConsumableArray(additionalNews));
              _context5.next = 19;
              break;
            case 15:
              _context5.prev = 15;
              _context5.t0 = _context5["catch"](8);
              toast.error('ニュースの取得に失敗しました');
              return _context5.abrupt("return");
            case 19:
              loading.value = false;
            case 20:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[8, 15]]);
      }));
      return function fetchAdditionalData(_x2) {
        return _ref5.apply(this, arguments);
      };
    }();
    var isDragging = false;
    var clickedCategoryName = null;
    var onMouseDown = function onMouseDown(categoryName) {
      isDragging = false;
      clickedCategoryName = categoryName;
    };
    var onMouseUp = function onMouseUp(event) {
      if (!isDragging && clickedCategoryName) {
        activeCategoryName.value = clickedCategoryName;
      }
      clickedCategoryName = null;
    };
    var onTabClick = function onTabClick(categoryName) {
      telemetry.sendClickTelemetry({
        button: 'news__tab',
        params: {
          categoryName: categoryName
        }
      }, route);
      if (!isDragging) {
        activeCategoryName.value = categoryName;
        updateActiveTabClass();
      }
    };
    var onClickHeadline = function onClickHeadline(headline, uri) {
      telemetry.sendClickTelemetry({
        button: 'news__headline',
        params: {
          headline: headline,
          uri: uri
        }
      }, route);
    };
    var onClickCategory = function onClickCategory(categoryName) {
      telemetry.sendClickTelemetry({
        button: 'news__category',
        params: {
          categoryName: categoryName
        }
      }, route);
    };
    var getGhostParent = function getGhostParent() {
      // ドラッグ可能な項目の親要素をposition: absoluteなどで位置を調整してしまうとドラッグオブジェクトの位置がズレる
      // 明示的にbodyを指定することで、ドラッグオブジェクトの位置がズレないようにする
      // https://github.com/kutlugsahin/vue-smooth-dnd?tab=readme-ov-file#get-ghost-parent
      return document.body;
    };
    var getNews = computed(function () {
      if (isMobile.value && firstLoad.value) {
        // モバイルでもっと見るボタンを押していない時は、最新の3件のみ表示
        return news.value.slice(0, MOBILE_LOAD_COUNT);
      }
      return news.value;
    });
    var skeltonCount = computed(function () {
      if (!firstLoad.value) {
        return ADDITIONAL_NEWS_COUNT;
      }
      if (isMobile.value) {
        return MOBILE_LOAD_COUNT;
      } else {
        return DEFAULT_LOAD_COUNT;
      }
    });
    var onDrop = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(dropResult) {
        var addedIndex, removedIndex, category, insertIndex, _category;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              addedIndex = dropResult.addedIndex, removedIndex = dropResult.removedIndex;
              category = categories.value.splice(removedIndex, 1)[0];
              categories.value.splice(addedIndex, 0, category);
              updateActiveTabClass();
              insertIndex = addedIndex < removedIndex ? addedIndex : addedIndex + 1;
              _context6.prev = 5;
              _context6.next = 8;
              return repositories.users.putUserNewsCategories(category.id.toString(), insertIndex);
            case 8:
              _context6.next = 17;
              break;
            case 10:
              _context6.prev = 10;
              _context6.t0 = _context6["catch"](5);
              toast.error('ニュースカテゴリの並び替えに失敗しました');
              // 元に戻す
              _category = categories.value.splice(addedIndex, 1)[0];
              categories.value.splice(removedIndex, 0, _category);
              updateActiveTabClass();
              return _context6.abrupt("return");
            case 17:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[5, 10]]);
      }));
      return function onDrop(_x3) {
        return _ref6.apply(this, arguments);
      };
    }();
    var onDragStart = function onDragStart() {
      isDragging = true;
    };
    var onResize = function onResize() {
      isMobile.value = window.innerWidth < MOBILE_WIDTH;
    };
    onBeforeMount(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            fetchTotalCount();
            fetchCountByCategory();

            // activeCategoryName.valueが必要なので、fetchCategoriesを先に実行し、かつawaitで待つ
            _context7.next = 4;
            return fetchCategories();
          case 4:
            fetchData(activeCategoryName.value);
          case 5:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    })));
    onMounted(function () {
      // ドラッグ中にマウスアップイベントが発生しないため、windowにマウスアップイベントを設定
      window.addEventListener('mouseup', onMouseUp);
      // ニュースのコンテンツ表示数が600pxを境に変わるので、resizeイベントを監視する
      onResize();
      window.addEventListener('resize', onResize);
    });
    onBeforeUnmount(function () {
      window.removeEventListener('mouseup', onMouseUp);
      window.removeEventListener('resize', onResize);
    });
    var updateActiveTabClass = function updateActiveTabClass() {
      // DnDとクリックの結果とactiveTabが正しく同期せず、activeTabの位置がずれる
      // FIXME: DOM操作でactiveTabの位置を修正
      var currentActiveTabIndex = categories.value.findIndex(function (c) {
        return c.name === activeCategoryName.value;
      });
      if (currentActiveTabIndex === -1) {
        return;
      }
      var allTabElements = document.querySelectorAll('.v-tabs-bar__content [role="tab"]');
      allTabElements.forEach(function (tab) {
        return tab.classList.remove('v-tab--active');
      });
      var activeTabElement = allTabElements[currentActiveTabIndex];
      if (activeTabElement) {
        activeTabElement.classList.add('v-tab--active');
      }
    };
    return {
      __sfc: true,
      SCROLL_DISTANCE: SCROLL_DISTANCE,
      MOBILE_WIDTH: MOBILE_WIDTH,
      content: content,
      isMobile: isMobile,
      totalCountLoading: totalCountLoading,
      totalCount: totalCount,
      countByCategoryLoading: countByCategoryLoading,
      countByCategory: countByCategory,
      activeCategoryName: activeCategoryName,
      categoriesLoading: categoriesLoading,
      categories: categories,
      news: news,
      loading: loading,
      telemetry: telemetry,
      route: route,
      repositories: repositories,
      toast: toast,
      directories: directories,
      ADDITIONAL_NEWS_COUNT: ADDITIONAL_NEWS_COUNT,
      MOBILE_LOAD_COUNT: MOBILE_LOAD_COUNT,
      DEFAULT_LOAD_COUNT: DEFAULT_LOAD_COUNT,
      firstLoad: firstLoad,
      showLoadMore: showLoadMore,
      onClickLoadMore: onClickLoadMore,
      fetchTotalCount: fetchTotalCount,
      fetchCountByCategory: fetchCountByCategory,
      getCount: getCount,
      fetchCategories: fetchCategories,
      updateHeight: updateHeight,
      fetchData: fetchData,
      scrollContentDown: scrollContentDown,
      fetchAdditionalData: fetchAdditionalData,
      isDragging: isDragging,
      clickedCategoryName: clickedCategoryName,
      onMouseDown: onMouseDown,
      onMouseUp: onMouseUp,
      onTabClick: onTabClick,
      onClickHeadline: onClickHeadline,
      onClickCategory: onClickCategory,
      getGhostParent: getGhostParent,
      getNews: getNews,
      skeltonCount: skeltonCount,
      onDrop: onDrop,
      onDragStart: onDragStart,
      onResize: onResize,
      updateActiveTabClass: updateActiveTabClass,
      PanelHeader: PanelHeader,
      Container: Container,
      Draggable: Draggable,
      Icon: Icon,
      VTabsItems: VTabsItems
    };
  }
});